module.exports = __webpack_public_path__ + "static/media/insufficient-physical-activity.ae081850.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/insufficient-physical-activity.svg
// module id = 884
// module chunks = 0 1